// import React, { useEffect, useState } from "react";
// import cleanJobDescription from "./cleanJobDescription";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Paper,
//   Button,
//   CircularProgress,
//   Container,
//   Grid,
//   Chip,
//   TextField,
//   Snackbar,
//   Divider,
//   MenuItem,
// } from "@mui/material";

// import { API_URL } from "./config";

// function stripHtml(html) {
//   const doc = new DOMParser().parseFromString(html, "text/html");
//   return doc.body.textContent || "";
// }

// function QuestionField({ q, value, onChange, form, setForm, submitting }) {
//   // Handles rendering the correct input type for a question
//   if (q.type === "boolean") {
//     return (
//       <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
//         <Typography sx={{ mr: 2 }}>{q.text}</Typography>
//         <input
//           type="checkbox"
//           name={`question_${q.id}`}
//           checked={!!form[`question_${q.id}`]}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, [`question_${q.id}`]: e.target.checked }))
//           }
//           disabled={submitting}
//         />
//       </Box>
//     );
//   }
//   if (q.type === "file") {
//     return (
//       <Box sx={{ mt: 1 }}>
//         <Typography>{q.text}</Typography>
//         <input
//           type="file"
//           name={`question_${q.id}`}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, [`question_${q.id}`]: e.target.files[0] }))
//           }
//           disabled={submitting}
//         />
//       </Box>
//     );
//   }
//   if (q.type === "select") {
//     return (
//       <TextField
//         select
//         label={q.text}
//         name={`question_${q.id}`}
//         value={value || ""}
//         onChange={onChange}
//         fullWidth
//         required={q.is_required}
//         disabled={submitting}
//       >
//         {(q.choices || []).map((choice, idx) => (
//           <MenuItem key={idx} value={choice}>
//             {choice}
//           </MenuItem>
//         ))}
//       </TextField>
//     );
//   }
//   // Default: text or number
//   return (
//     <TextField
//       label={q.text}
//       name={`question_${q.id}`}
//       required={q.is_required}
//       fullWidth
//       value={value || ""}
//       onChange={onChange}
//       type={q.type === "number" ? "number" : "text"}
//       disabled={submitting}
//     />
//   );
// }

// export default function ApplyPage() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [form, setForm] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   useEffect(() => {
//     fetch(`${API_URL}/joborder/${id}/uprotected`)
//       .then((res) => res.json())
//       .then((data) => {
//         let jobData = data;
//         if (Array.isArray(data)) {
//           jobData = data.length > 0 ? data[0] : null;
//         }
//         setJob(jobData);
//       })
//       .catch(() => setError("Failed to load job"))
//       .finally(() => setLoading(false));
//   }, [id]);

//   if (loading)
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//         <CircularProgress />
//       </Box>
//     );
//   if (error || !job)
//     return (
//       <Typography color="error" align="center">
//         {error || "Job not found."}
//       </Typography>
//     );

//   // Prepare questions from job.questions
//   const allQuestions = Array.isArray(job.questions) ? job.questions : [];
//   // Only show questions actually attached to this job order
//   const filteredQuestions = allQuestions.filter((q) =>
//     job.questions.some((jq) => jq.id === q.id)
//   );
//   const defaultQuestions = filteredQuestions
//     .filter((q) => q.is_default)
//     .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
//   const otherQuestions = filteredQuestions
//     .filter((q) => !q.is_default)
//     .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

//   const handleChange = (e) => {
//     setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Validate applicant fields
//     if (
//       !form.applicant_name ||
//       !form.applicant_email ||
//       !form.phone ||
//       !form.resume
//     ) {
//       setSnackbar({
//         open: true,
//         message: "Full Name, Email, Phone, and Resume are required.",
//         severity: "error",
//       });
//       return;
//     }
//     setSubmitting(true);
//     try {
//       // Prepare answers for all questions (handle file and boolean types)
//       const answers = {};
//       let hasFile = false;
//       filteredQuestions.forEach((q) => {
//         // Skip applicant_name/email if present as questions
//         if (["full name", "email"].includes(q.text.toLowerCase().trim()))
//           return;
//         const key = `question_${q.id}`;
//         if (q.type === "file" && form[key]) {
//           hasFile = true;
//         }
//         if (q.type === "boolean") {
//           answers[key] = !!form[key];
//         } else if (q.type === "file") {
//           answers[key] = form[key] || null;
//         } else {
//           answers[key] = form[key] || "";
//         }
//       });
//       let payload = new FormData();
//       Object.entries(answers).forEach(([k, v]) => {
//         if (
//           filteredQuestions.find(
//             (q) => `question_${q.id}` === k && q.type === "file"
//           )
//         ) {
//           if (v) payload.append(k, v);
//         } else {
//           payload.append(k, v);
//         }
//       });
//       payload.append("job_order_id", id);
//       payload.append("applicant_name", form.applicant_name);
//       payload.append("applicant_email", form.applicant_email);
//       payload.append("phone", form.phone);
//       payload.append("resume", form.resume);
//       payload.append("answers", JSON.stringify(answers));
//       const res = await fetch(`${API_URL}/applications/`, {
//         method: "POST",
//         body: payload,
//       });
//       if (!res.ok) {
//         let errMsg = 'Failed to submit application';
//         try {
//           const data = await res.json();
//           if (data.detail) {
//             errMsg = data.detail;
//           } else if (data.error && (data.error.message || data.error.detail)) {
//             errMsg = data.error.message || data.error.detail;
//           }
//         } catch {}
//         setSnackbar({ open: true, message: errMsg, severity: 'error' });
//         throw new Error(errMsg);
//       }
//       setSnackbar({
//         open: true,
//         message: "Application submitted successfully!",
//         severity: "success",
//       });
//       navigate("/thank-you");
//     } catch (err) {
//       setSnackbar({ open: true, message: err.message, severity: "error" });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Container maxWidth="md" sx={{ py: 6 }}>
//       <Paper sx={{ p: 4, borderRadius: 3, mb: 3 }}>
//         <Box
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           mb={2}
//         >
//           <Typography variant="h4" sx={{ fontWeight: 700 }}>
//             {job.job_title}
//           </Typography>
//           <Button
//             variant="contained"
//             size="large"
//             onClick={() =>
//               document
//                 .getElementById("apply-form")
//                 .scrollIntoView({ behavior: "smooth" })
//             }
//           >
//             Apply Now
//           </Button>
//         </Box>
//         <Typography variant="subtitle1" color="text.secondary" mb={1}>
//           {/* {job.department} |{" "} */}
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
//             {(job.locations && job.locations.length > 0
//               ? job.locations
//               : job?.locations && job?.locations.length > 0
//               ? job?.locations
//               : []
//             ).length > 0 ? (
//               (job.locations && job.locations.length > 0
//                 ? job.locations
//                 : job?.locations || []
//               ).map((loc, idx) => (
//                 <Chip
//                   key={loc.id || loc.name || idx}
//                   label={loc.name}
//                   color={
//                     [
//                       "primary",
//                       "secondary",
//                       "success",
//                       "warning",
//                       "info",
//                       "error",
//                     ][idx % 6]
//                   }
//                   variant="filled"
//                 />
//               ))
//             ) : (
//               <Chip label="-" color="default" variant="outlined" />
//             )}
//           </Box>
//         </Typography>
//         <Box sx={{ my: 3 }}>
//           {/* Render formatted HTML safely */}
//           <div
//             dangerouslySetInnerHTML={{
//               __html: cleanJobDescription(
//                 job.job && job.job_description
//                   ? job.job_description
//                   : job.job_description || "No job description provided."
//               ),
//             }}
//           />
//         </Box>
//         <Typography variant="body2" color="text.secondary" mb={2}>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               mb: 1,
//               flexWrap: "wrap",
//               gap: 1,
//             }}
//           >
//             <b>Type:</b>
//             {job.job_types && job.job_types.length > 0 ? (
//               job.job_types.map((type, idx) => (
//                 <Chip
//                   key={type.id || type.name || idx}
//                   label={type.name}
//                   color={
//                     [
//                       "primary",
//                       "secondary",
//                       "success",
//                       "warning",
//                       "info",
//                       "error",
//                     ][idx % 6]
//                   }
//                   variant="filled"
//                   sx={{ ml: 1 }}
//                 />
//               ))
//             ) : (
//               <Chip
//                 label="-"
//                 color="default"
//                 variant="outlined"
//                 sx={{ ml: 1 }}
//               />
//             )}
//           </Box>{" "}
//           <br />
//           &nbsp;
//           <b>Apply Before:</b>{" "}
//           {job.end_date
//             ? window.dayjs
//               ? window.dayjs(job.end_date).format(" D MMMM, YYYY, h:mm A")
//               : new Date(job.end_date).toLocaleString()
//             : "-"}
//         </Typography>
//         <Button
//           variant="contained"
//           size="large"
//           sx={{ mt: 2 }}
//           onClick={() =>
//             document
//               .getElementById("apply-form")
//               .scrollIntoView({ behavior: "smooth" })
//           }
//         >
//           Apply Now
//         </Button>
//       </Paper>
//       <Paper sx={{ p: 4, borderRadius: 3 }} id="apply-form">
//         <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
//           Application Form
//         </Typography>
//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             {/* Applicant Info Fields (required) */}
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Full Name"
//                 name="applicant_name"
//                 required
//                 fullWidth
//                 value={form.applicant_name || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Email"
//                 name="applicant_email"
//                 required
//                 type="email"
//                 fullWidth
//                 value={form.applicant_email || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Phone Number"
//                 name="phone"
//                 type="tel"
//                 required
//                 fullWidth
//                 value={form.phone || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//                 inputProps={{ pattern: "[0-9-+() ]*" }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <Button
//                 variant="contained"
//                 component="label"
//                 color="secondary"
//                 fullWidth
//                 disabled={submitting}
//                 sx={{ mb: 1 }}
//               >
//                 Upload Resume (PDF/DOC)
//                 <input
//                   type="file"
//                   name="resume"
//                   accept=".pdf,.doc,.docx,application/pdf,application/msword"
//                   hidden
//                   required
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, resume: e.target.files[0] }))
//                   }
//                   disabled={submitting}
//                 />
//               </Button>
//               {form.resume && (
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ ml: 0.5, mt: 0.5 }}
//                 >
//                   Selected: {form.resume.name}
//                 </Typography>
//               )}
//             </Grid>
//             {/* Default questions first */}
//             {defaultQuestions
//               .filter(
//                 (q) =>
//                   !["full name", "email"].includes(q.text.toLowerCase().trim())
//               )
//               .map((q) => (
//                 <Grid item xs={12} key={q.id}>
//                   <QuestionField
//                     q={q}
//                     value={form[`question_${q.id}`]}
//                     onChange={handleChange}
//                     form={form}
//                     setForm={setForm}
//                     submitting={submitting}
//                   />
//                   {q.description && (
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ ml: 0.5, mt: 0.5 }}
//                     >
//                       {q.description}
//                     </Typography>
//                   )}
//                 </Grid>
//               ))}
//             {/* Divider if there are other questions */}
//             {defaultQuestions.length > 0 && otherQuestions.length > 0 && (
//               <Grid item xs={12}>
//                 <Divider sx={{ my: 2 }} />
//               </Grid>
//             )}
//             {/* Other questions */}
//             {otherQuestions
//               .filter(
//                 (q) =>
//                   !["full name", "email"].includes(q.text.toLowerCase().trim())
//               )
//               .map((q) => (
//                 <Grid item xs={12} key={q.id}>
//                   <QuestionField
//                     q={q}
//                     value={form[`question_${q.id}`]}
//                     onChange={handleChange}
//                     form={form}
//                     setForm={setForm}
//                     submitting={submitting}
//                   />
//                   {q.description && (
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ ml: 0.5, mt: 0.5 }}
//                     >
//                       {q.description}
//                     </Typography>
//                   )}
//                 </Grid>
//               ))}

//             <Grid item xs={12}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 size="large"
//                 disabled={submitting}
//               >
//                 {submitting ? "Submitting..." : "Submit Application"}
//               </Button>
//             </Grid>
//           </Grid>
//         </form>
//       </Paper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         message={snackbar.message}
//       />
//     </Container>
//   );
// }


// import React, { useEffect, useState } from "react";
// import cleanJobDescription from "./cleanJobDescription";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Paper,
//   Button,
//   CircularProgress,
//   Container,
//   Grid,
//   Chip,
//   TextField,
//   Snackbar,
//   Divider,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";

// import { API_URL } from "./config";

// function stripHtml(html) {
//   const doc = new DOMParser().parseFromString(html, "text/html");
//   return doc.body.textContent || "";
// }

// function normalizePhone(phone) {
//   if (!phone) return "";

//   let normalized = String(phone).trim().replace(/\s+/g, "").replace(/-/g, "");

//   if (normalized.startsWith("+")) {
//     normalized = normalized.slice(1);
//   }

//   if (normalized.startsWith("0") && normalized.length === 10) {
//     normalized = `254${normalized.slice(1)}`;
//   }

//   return normalized;
// }

// function QuestionField({ q, value, onChange, form, setForm, submitting }) {
//   if (q.type === "boolean") {
//     return (
//       <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
//         <Typography sx={{ mr: 2 }}>{q.text}</Typography>
//         <input
//           type="checkbox"
//           name={`question_${q.id}`}
//           checked={!!form[`question_${q.id}`]}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, [`question_${q.id}`]: e.target.checked }))
//           }
//           disabled={submitting}
//         />
//       </Box>
//     );
//   }

//   if (q.type === "file") {
//     return (
//       <Box sx={{ mt: 1 }}>
//         <Typography>{q.text}</Typography>
//         <input
//           type="file"
//           name={`question_${q.id}`}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, [`question_${q.id}`]: e.target.files[0] }))
//           }
//           disabled={submitting}
//         />
//       </Box>
//     );
//   }

//   if (q.type === "select") {
//     return (
//       <TextField
//         select
//         label={q.text}
//         name={`question_${q.id}`}
//         value={value || ""}
//         onChange={onChange}
//         fullWidth
//         required={q.is_required}
//         disabled={submitting}
//       >
//         {(q.choices || []).map((choice, idx) => (
//           <MenuItem key={idx} value={choice}>
//             {choice}
//           </MenuItem>
//         ))}
//       </TextField>
//     );
//   }

//   return (
//     <TextField
//       label={q.text}
//       name={`question_${q.id}`}
//       required={q.is_required}
//       fullWidth
//       value={value || ""}
//       onChange={onChange}
//       type={q.type === "number" ? "number" : "text"}
//       disabled={submitting}
//     />
//   );
// }

// export default function ApplyPage() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [form, setForm] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const [paymentConsent, setPaymentConsent] = useState(false);
//   const [paymentId, setPaymentId] = useState("");
//   const [paymentStatus, setPaymentStatus] = useState("NOT_STARTED");
//   const [paymentMessage, setPaymentMessage] = useState("");
//   const [initiatingPayment, setInitiatingPayment] = useState(false);

//   const requiresApplicationFee = true;
//   const applicationFeeAmount = Number(1000).toLocaleString();
//   const applicationFeeCurrency = "KES";
//   const applicationFeeDescription = "Application fee";

//   useEffect(() => {
//     fetch(`${API_URL}/joborder/${id}/uprotected`)
//       .then((res) => res.json())
//       .then((data) => {
//         let jobData = data;
//         if (Array.isArray(data)) {
//           jobData = data.length > 0 ? data[0] : null;
//         }
//         setJob(jobData);
//       })
//       .catch(() => setError("Failed to load job"))
//       .finally(() => setLoading(false));
//   }, [id]);

//   useEffect(() => {
//     if (!paymentId || paymentStatus !== "PENDING") return;

//     const interval = setInterval(async () => {
//       try {
//         const res = await fetch(
//           `${API_URL}/application-payments/${paymentId}/status`
//         );
//         const data = await res.json();

//         if (!res.ok) {
//           throw new Error(data.detail || "Failed to check payment status.");
//         }

//         setPaymentStatus(data.status || "PENDING");
//         setPaymentMessage(data.message || "");

//         if (data.status === "SUCCESS") {
//           setSnackbar({
//             open: true,
//             message: "Payment confirmed. You can now submit your application.",
//             severity: "success",
//           });
//         }
//       } catch (err) {
//         setPaymentMessage(err.message || "Failed to check payment status.");
//       }
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [paymentId, paymentStatus]);

//   if (loading)
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//         <CircularProgress />
//       </Box>
//     );

//   if (error || !job)
//     return (
//       <Typography color="error" align="center">
//         {error || "Job not found."}
//       </Typography>
//     );

//   const allQuestions = Array.isArray(job.questions) ? job.questions : [];
//   const filteredQuestions = allQuestions.filter((q) =>
//     job.questions.some((jq) => jq.id === q.id)
//   );

//   const defaultQuestions = filteredQuestions
//     .filter((q) => q.is_default)
//     .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

//   const otherQuestions = filteredQuestions
//     .filter((q) => !q.is_default)
//     .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

//   const handleChange = (e) => {
//     setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
//   };

//   const validateCoreApplicantFields = () => {
//     if (
//       !form.applicant_name ||
//       !form.applicant_email ||
//       !form.phone ||
//       !form.resume
//     ) {
//       setSnackbar({
//         open: true,
//         message: "Full Name, Email, Phone, and Resume are required.",
//         severity: "error",
//       });
//       return false;
//     }

//     return true;
//   };

//   const handleInitiatePayment = async () => {
//     if (!validateCoreApplicantFields()) return;

//     if (!paymentConsent) {
//       setSnackbar({
//         open: true,
//         message: "Please confirm that you are willing to pay the application fee.",
//         severity: "error",
//       });
//       return;
//     }

//     const normalizedPhone = normalizePhone(form.phone);

//     setInitiatingPayment(true);
//     try {
//       const res = await fetch(`${API_URL}/application-payments/initiate`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           job_order_id: id,
//           applicant_email: form.applicant_email,
//           applicant_name: form.applicant_name,
//           phone: normalizedPhone,
//         }),
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         throw new Error(data.detail || "Failed to initiate payment.");
//       }

//       setPaymentId(data.payment_id);
//       setPaymentStatus(data.status || "PENDING");
//       setPaymentMessage(data.message || "Payment prompt sent to your phone.");

//       setForm((f) => ({
//         ...f,
//         phone: normalizedPhone,
//       }));

//       if (data.status === "SUCCESS") {
//         setSnackbar({
//           open: true,
//           message: "Payment confirmed. You can now submit your application.",
//           severity: "success",
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: data.message || "Payment prompt sent to your phone.",
//           severity: "success",
//         });
//       }
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Failed to initiate payment.",
//         severity: "error",
//       });
//     } finally {
//       setInitiatingPayment(false);
//     }
//   };

//   const handleRefreshPaymentStatus = async () => {
//     if (!paymentId) return;

//     try {
//       const res = await fetch(
//         `${API_URL}/application-payments/${paymentId}/status`
//       );
//       const data = await res.json();

//       if (!res.ok) {
//         throw new Error(data.detail || "Failed to check payment status.");
//       }

//       setPaymentStatus(data.status || "PENDING");
//       setPaymentMessage(data.message || "");

//       if (data.status === "SUCCESS") {
//         setSnackbar({
//           open: true,
//           message: "Payment confirmed. You can now submit your application.",
//           severity: "success",
//         });
//       }
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Failed to check payment status.",
//         severity: "error",
//       });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateCoreApplicantFields()) {
//       return;
//     }

//     if (requiresApplicationFee && (paymentStatus !== "SUCCESS" || !paymentId)) {
//       setSnackbar({
//         open: true,
//         message: "Please complete payment before submitting your application.",
//         severity: "error",
//       });
//       return;
//     }

//     const normalizedPhone = normalizePhone(form.phone);

//     setSubmitting(true);
//     try {
//       const answers = {};
//       filteredQuestions.forEach((q) => {
//         if (["full name", "email"].includes(q.text.toLowerCase().trim()))
//           return;

//         const key = `question_${q.id}`;

//         if (q.type === "boolean") {
//           answers[key] = !!form[key];
//         } else if (q.type === "file") {
//           answers[key] = form[key] || null;
//         } else {
//           answers[key] = form[key] || "";
//         }
//       });

//       let payload = new FormData();

//       Object.entries(answers).forEach(([k, v]) => {
//         if (
//           filteredQuestions.find(
//             (q) => `question_${q.id}` === k && q.type === "file"
//           )
//         ) {
//           if (v) payload.append(k, v);
//         } else {
//           payload.append(k, v);
//         }
//       });

//       payload.append("job_order_id", id);
//       payload.append("applicant_name", form.applicant_name);
//       payload.append("applicant_email", form.applicant_email);
//       payload.append("phone", normalizedPhone);
//       payload.append("resume", form.resume);
//       payload.append("answers", JSON.stringify(answers));
//       payload.append("payment_id", paymentId);

//       const res = await fetch(`${API_URL}/applications/`, {
//         method: "POST",
//         body: payload,
//       });

//       if (!res.ok) {
//         let errMsg = "Failed to submit application";
//         try {
//           const data = await res.json();
//           if (data.detail) {
//             errMsg = data.detail;
//           } else if (data.error && (data.error.message || data.error.detail)) {
//             errMsg = data.error.message || data.error.detail;
//           }
//         } catch {}
//         setSnackbar({ open: true, message: errMsg, severity: "error" });
//         throw new Error(errMsg);
//       }

//       setSnackbar({
//         open: true,
//         message: "Application submitted successfully!",
//         severity: "success",
//       });
//       navigate("/thank-you");
//     } catch (err) {
//       setSnackbar({ open: true, message: err.message, severity: "error" });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Container maxWidth="md" sx={{ py: 6 }}>
//       <Paper sx={{ p: 4, borderRadius: 3, mb: 3 }}>
//         <Box
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           mb={2}
//         >
//           <Typography variant="h4" sx={{ fontWeight: 700 }}>
//             {job.job_title}
//           </Typography>
//           <Button
//             variant="contained"
//             size="large"
//             onClick={() =>
//               document
//                 .getElementById("apply-form")
//                 .scrollIntoView({ behavior: "smooth" })
//             }
//           >
//             Apply Now
//           </Button>
//         </Box>

//         <Typography variant="subtitle1" color="text.secondary" mb={1}>
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
//             {(job.locations && job.locations.length > 0
//               ? job.locations
//               : job?.locations && job?.locations.length > 0
//               ? job?.locations
//               : []
//             ).length > 0 ? (
//               (job.locations && job.locations.length > 0
//                 ? job.locations
//                 : job?.locations || []
//               ).map((loc, idx) => (
//                 <Chip
//                   key={loc.id || loc.name || idx}
//                   label={loc.name}
//                   color={
//                     [
//                       "primary",
//                       "secondary",
//                       "success",
//                       "warning",
//                       "info",
//                       "error",
//                     ][idx % 6]
//                   }
//                   variant="filled"
//                 />
//               ))
//             ) : (
//               <Chip label="-" color="default" variant="outlined" />
//             )}
//           </Box>
//         </Typography>

//         <Box sx={{ my: 3 }}>
//           <div
//             dangerouslySetInnerHTML={{
//               __html: cleanJobDescription(
//                 job.job && job.job_description
//                   ? job.job_description
//                   : job.job_description || "No job description provided."
//               ),
//             }}
//           />
//         </Box>

//         <Typography variant="body2" color="text.secondary" mb={2}>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               mb: 1,
//               flexWrap: "wrap",
//               gap: 1,
//             }}
//           >
//             <b>Type:</b>
//             {job.job_types && job.job_types.length > 0 ? (
//               job.job_types.map((type, idx) => (
//                 <Chip
//                   key={type.id || type.name || idx}
//                   label={type.name}
//                   color={
//                     [
//                       "primary",
//                       "secondary",
//                       "success",
//                       "warning",
//                       "info",
//                       "error",
//                     ][idx % 6]
//                   }
//                   variant="filled"
//                   sx={{ ml: 1 }}
//                 />
//               ))
//             ) : (
//               <Chip
//                 label="-"
//                 color="default"
//                 variant="outlined"
//                 sx={{ ml: 1 }}
//               />
//             )}
//           </Box>{" "}
//           <br />
//           &nbsp;
//           <b>Apply Before:</b>{" "}
//           {job.end_date
//             ? window.dayjs
//               ? window.dayjs(job.end_date).format(" D MMMM, YYYY, h:mm A")
//               : new Date(job.end_date).toLocaleString()
//             : "-"}
//         </Typography>

//         <Button
//           variant="contained"
//           size="large"
//           sx={{ mt: 2 }}
//           onClick={() =>
//             document
//               .getElementById("apply-form")
//               .scrollIntoView({ behavior: "smooth" })
//           }
//         >
//           Apply Now
//         </Button>
//       </Paper>

//       <Paper sx={{ p: 4, borderRadius: 3 }} id="apply-form">
//         <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
//           Application Form
//         </Typography>

//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Full Name"
//                 name="applicant_name"
//                 required
//                 fullWidth
//                 value={form.applicant_name || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Email"
//                 name="applicant_email"
//                 required
//                 type="email"
//                 fullWidth
//                 value={form.applicant_email || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <TextField
//                 label="Phone Number"
//                 name="phone"
//                 type="tel"
//                 required
//                 fullWidth
//                 value={form.phone || ""}
//                 onChange={handleChange}
//                 disabled={submitting}
//                 inputProps={{ inputMode: "tel" }}
//                 // inputProps={{ pattern: "[0-9()+ -]*" }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Button
//                 variant="contained"
//                 component="label"
//                 color="secondary"
//                 fullWidth
//                 disabled={submitting}
//                 sx={{ mb: 1 }}
//               >
//                 Upload Resume (PDF/DOC)
//                 <input
//                   type="file"
//                   name="resume"
//                   accept=".pdf,.doc,.docx,application/pdf,application/msword"
//                   hidden
//                   required
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, resume: e.target.files[0] }))
//                   }
//                   disabled={submitting}
//                 />
//               </Button>
//               {form.resume && (
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ ml: 0.5, mt: 0.5 }}
//                 >
//                   Selected: {form.resume.name}
//                 </Typography>
//               )}
//             </Grid>

//             {defaultQuestions
//               .filter(
//                 (q) =>
//                   !["full name", "email"].includes(q.text.toLowerCase().trim())
//               )
//               .map((q) => (
//                 <Grid item xs={12} key={q.id}>
//                   <QuestionField
//                     q={q}
//                     value={form[`question_${q.id}`]}
//                     onChange={handleChange}
//                     form={form}
//                     setForm={setForm}
//                     submitting={submitting}
//                   />
//                   {q.description && (
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ ml: 0.5, mt: 0.5 }}
//                     >
//                       {q.description}
//                     </Typography>
//                   )}
//                 </Grid>
//               ))}

//             {defaultQuestions.length > 0 && otherQuestions.length > 0 && (
//               <Grid item xs={12}>
//                 <Divider sx={{ my: 2 }} />
//               </Grid>
//             )}

//             {otherQuestions
//               .filter(
//                 (q) =>
//                   !["full name", "email"].includes(q.text.toLowerCase().trim())
//               )
//               .map((q) => (
//                 <Grid item xs={12} key={q.id}>
//                   <QuestionField
//                     q={q}
//                     value={form[`question_${q.id}`]}
//                     onChange={handleChange}
//                     form={form}
//                     setForm={setForm}
//                     submitting={submitting}
//                   />
//                   {q.description && (
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ ml: 0.5, mt: 0.5 }}
//                     >
//                       {q.description}
//                     </Typography>
//                   )}
//                 </Grid>
//               ))}

//             {requiresApplicationFee && (
//               <Grid item xs={12}>
//                 <Divider sx={{ my: 2 }} />

//                 <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
//                   Application Fee
//                 </Typography>

//                 <Typography variant="body1" sx={{ mb: 1 }}>
//                   {applicationFeeDescription}:{" "}
//                   <b>
//                     {applicationFeeCurrency} {applicationFeeAmount}
//                   </b>
//                 </Typography>

//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={paymentConsent}
//                       onChange={(e) => setPaymentConsent(e.target.checked)}
//                       disabled={
//                         submitting ||
//                         initiatingPayment ||
//                         paymentStatus === "SUCCESS"
//                       }
//                     />
//                   }
//                   label={`I understand that submitting this application requires a non-refundable application fee of ${applicationFeeCurrency} ${applicationFeeAmount}.`}
//                 />

//                 <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
//                   <Button
//                     type="button"
//                     variant="contained"
//                     color="secondary"
//                     onClick={handleInitiatePayment}
//                     disabled={
//                       submitting ||
//                       initiatingPayment ||
//                       paymentStatus === "SUCCESS" ||
//                       !paymentConsent
//                     }
//                   >
//                     {initiatingPayment
//                       ? "Initiating Payment..."
//                       : paymentStatus === "SUCCESS"
//                       ? "Payment Completed"
//                       : `Pay ${applicationFeeCurrency} ${applicationFeeAmount}`}
//                   </Button>

//                   {paymentId && paymentStatus !== "SUCCESS" && (
//                     <Button
//                       type="button"
//                       variant="outlined"
//                       onClick={handleRefreshPaymentStatus}
//                       disabled={submitting || initiatingPayment}
//                     >
//                       Refresh Payment Status
//                     </Button>
//                   )}
//                 </Box>

//                 {paymentMessage && (
//                   <Typography
//                     variant="body2"
//                     color={
//                       paymentStatus === "SUCCESS"
//                         ? "success.main"
//                         : paymentStatus === "FAILED" ||
//                           paymentStatus === "CANCELLED" ||
//                           paymentStatus === "EXPIRED"
//                         ? "error.main"
//                         : "text.secondary"
//                     }
//                     sx={{ mt: 1.5 }}
//                   >
//                     {paymentMessage}
//                   </Typography>
//                 )}

//                 {paymentStatus === "PENDING" && (
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                     Check your phone and complete the M-Pesa prompt. Once payment
//                     is confirmed, the submit button will be enabled automatically.
//                   </Typography>
//                 )}

//                 {paymentStatus === "SUCCESS" && (
//                   <Typography variant="body2" color="success.main" sx={{ mt: 1 }}>
//                     Payment confirmed. You can now submit your application.
//                   </Typography>
//                 )}
//               </Grid>
//             )}

//             <Grid item xs={12}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 size="large"
//                 disabled={
//                   submitting ||
//                   (requiresApplicationFee &&
//                     (paymentStatus !== "SUCCESS" || !paymentId))
//                 }
//               >
//                 {submitting
//                   ? "Submitting..."
//                   : requiresApplicationFee &&
//                     (paymentStatus !== "SUCCESS" || !paymentId)
//                   ? "Complete Payment to Submit Application"
//                   : "Submit Application"}
//               </Button>
//             </Grid>
//           </Grid>
//         </form>
//       </Paper>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         message={snackbar.message}
//       />
//     </Container>
//   );
// }

import React, { useEffect, useState } from "react";
import cleanJobDescription from "./cleanJobDescription";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Container,
  Grid,
  Chip,
  TextField,
  Snackbar,
  Divider,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { API_URL } from "./config";

function normalizePhone(phone) {
  if (!phone) return "";

  let normalized = String(phone).trim().replace(/\s+/g, "").replace(/-/g, "");

  if (normalized.startsWith("+")) {
    normalized = normalized.slice(1);
  }

  if (normalized.startsWith("0") && normalized.length === 10) {
    normalized = `254${normalized.slice(1)}`;
  }

  return normalized;
}

function formatDeadline(value) {
  if (!value) return "-";
  return window.dayjs
    ? window.dayjs(value).format("D MMMM, YYYY, h:mm A")
    : new Date(value).toLocaleString();
}

function SectionEyebrow({ children, color, mono }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: mono,
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

function QuestionField({
  q,
  value,
  onChange,
  form,
  setForm,
  submitting,
  ui,
  brandMono,
}) {
  const sharedFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px",
      background: ui.fieldBg,
      color: ui.text,
      transition: "all .2s ease",
      "& fieldset": {
        borderColor: ui.border,
      },
      "&:hover fieldset": {
        borderColor: ui.borderStrong,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 0 4px ${alpha(ui.accent, 0.12)}`,
      },
      "&.Mui-focused fieldset": {
        borderColor: ui.accent,
      },
    },
    "& .MuiInputLabel-root": {
      color: ui.mid,
      fontWeight: 500,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: ui.accent,
    },
    "& .MuiFormHelperText-root": {
      color: ui.muted,
      mx: 0.25,
      mt: 1,
    },
    "& .MuiInputBase-input::placeholder": {
      color: ui.muted,
      opacity: 1,
    },
  };

  if (q.type === "boolean") {
    return (
      <Box
        sx={{
          p: 2,
          borderRadius: "16px",
          border: `1px solid ${ui.border}`,
          background: ui.fieldBg,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={!!form[`question_${q.id}`]}
              onChange={(e) =>
                setForm((f) => ({
                  ...f,
                  [`question_${q.id}`]: e.target.checked,
                }))
              }
              disabled={submitting}
              sx={{
                color: alpha(ui.accent, 0.6),
                "&.Mui-checked": {
                  color: ui.accent,
                },
              }}
            />
          }
          label={
            <Typography
              sx={{
                color: ui.text,
                fontWeight: 500,
                lineHeight: 1.6,
              }}
            >
              {q.text}
            </Typography>
          }
          sx={{ alignItems: "flex-start", m: 0 }}
        />

        {q.description && (
          <Typography
            sx={{
              mt: 0.5,
              ml: 4.5,
              color: ui.muted,
              fontSize: "13px",
              lineHeight: 1.7,
            }}
          >
            {q.description}
          </Typography>
        )}
      </Box>
    );
  }

  if (q.type === "file") {
    const fileValue = form[`question_${q.id}`];

    return (
      <Box
        sx={{
          p: 2.25,
          borderRadius: "16px",
          border: `1px solid ${ui.border}`,
          background: ui.fieldBg,
        }}
      >
        <Typography
          sx={{
            color: ui.text,
            fontWeight: 600,
            mb: 1,
          }}
        >
          {q.text}
          {q.is_required ? " *" : ""}
        </Typography>

        {q.description && (
          <Typography
            sx={{
              color: ui.muted,
              fontSize: "13px",
              lineHeight: 1.7,
              mb: 1.5,
            }}
          >
            {q.description}
          </Typography>
        )}

        <Button
          component="label"
          disabled={submitting}
          variant="outlined"
          sx={{
            borderRadius: "12px",
            px: 2,
            py: 1.1,
            textTransform: "none",
            fontWeight: 700,
            borderColor: alpha(ui.accent, 0.26),
            color: ui.accent,
            background: alpha(ui.accent, 0.06),
            "&:hover": {
              borderColor: ui.accent,
              background: alpha(ui.accent, 0.1),
            },
          }}
        >
          Upload file
          <input
            type="file"
            hidden
            name={`question_${q.id}`}
            onChange={(e) =>
              setForm((f) => ({
                ...f,
                [`question_${q.id}`]: e.target.files?.[0] || null,
              }))
            }
            disabled={submitting}
          />
        </Button>

        {fileValue && (
          <Typography
            sx={{
              mt: 1.25,
              color: ui.mid,
              fontSize: "13px",
              fontFamily: brandMono,
              wordBreak: "break-word",
            }}
          >
            Selected: {fileValue.name}
          </Typography>
        )}
      </Box>
    );
  }

  if (q.type === "select") {
    return (
      <TextField
        select
        label={q.text}
        name={`question_${q.id}`}
        value={value || ""}
        onChange={onChange}
        fullWidth
        required={q.is_required}
        disabled={submitting}
        helperText={q.description || " "}
        sx={sharedFieldSx}
      >
        {(q.choices || []).map((choice, idx) => (
          <MenuItem key={idx} value={choice}>
            {choice}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  return (
    <TextField
      label={q.text}
      name={`question_${q.id}`}
      required={q.is_required}
      fullWidth
      value={value || ""}
      onChange={onChange}
      type={q.type === "number" ? "number" : q.type === "email" ? "email" : "text"}
      multiline={q.type === "textarea"}
      minRows={q.type === "textarea" ? 4 : undefined}
      disabled={submitting}
      helperText={q.description || " "}
      sx={sharedFieldSx}
    />
  );
}

export default function ApplyPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const brandSans = `"Plus Jakarta Sans", ${theme.typography.fontFamily}`;
  const brandMono = `"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace`;

  const ui = {
    accent: dark ? "#fb923c" : "#f97316",
    pageBg: dark ? "#07080f" : "#ffffff",
    surfaceBg: dark ? "#0d1220" : "#f8f8fb",
    cardBg: dark ? "#0d1220" : "#ffffff",
    text: dark ? "#e8f0fe" : "#0f0f1a",
    mid: dark ? "#94a3b8" : "#4b4b6a",
    muted: dark ? "#4b6080" : "#9898b8",
    border: dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0",
    borderStrong: dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4",
    fieldBg: dark ? "rgba(8,12,24,0.7)" : "#ffffff",
  };

  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [paymentConsent, setPaymentConsent] = useState(false);
  const [paymentId, setPaymentId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("NOT_STARTED");
  const [paymentMessage, setPaymentMessage] = useState("");
  const [initiatingPayment, setInitiatingPayment] = useState(false);

  // const requiresApplicationFee = true;
  // const applicationFeeAmount = Number(10).toLocaleString();
  // const applicationFeeCurrency = "KES";
  // const applicationFeeDescription = "Application fee";

  const requiresApplicationFee = !!job?.requires_application_fee;
  const applicationFeeAmount =
    job?.application_fee_amount !== null &&
    job?.application_fee_amount !== undefined
      ? Number(job.application_fee_amount).toLocaleString()
      : "";
  const applicationFeeCurrency = job?.application_fee_currency || "KES";
  const applicationFeeDescription =
    job?.application_fee_description || "Application fee";

  const [feeNoticeOpen, setFeeNoticeOpen] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/joborder/${id}/uprotected`)
      .then((res) => res.json())
      .then((data) => {
        let jobData = data;
        if (Array.isArray(data)) {
          jobData = data.length > 0 ? data[0] : null;
        }
        setJob(jobData);
      })
      .catch(() => setError("Failed to load job"))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (!paymentId || paymentStatus !== "PENDING") return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_URL}/application-payments/${paymentId}/status`
        );
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.detail || "Failed to check payment status.");
        }

        setPaymentStatus(data.status || "PENDING");
        setPaymentMessage(data.message || "");

        if (data.status === "SUCCESS") {
          setSnackbar({
            open: true,
            message: "Payment confirmed. You can now submit your application.",
            severity: "success",
          });
        }
      } catch (err) {
        setPaymentMessage(err.message || "Failed to check payment status.");
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [paymentId, paymentStatus]);

  const scrollToForm = () => {
    document.getElementById("apply-form")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const validateCoreApplicantFields = () => {
    if (
      !form.applicant_name ||
      !form.applicant_email ||
      !form.phone ||
      !form.resume
    ) {
      setSnackbar({
        open: true,
        message: "Full Name, Email, Phone, and Resume are required.",
        severity: "error",
      });
      return false;
    }
    return true;
  };

  const handleInitiatePayment = async () => {
    if (!validateCoreApplicantFields()) return;

    if (!paymentConsent) {
      setSnackbar({
        open: true,
        message: "Please confirm that you are willing to pay the application fee.",
        severity: "error",
      });
      return;
    }

    const normalizedPhone = normalizePhone(form.phone);

    setInitiatingPayment(true);
    try {
      const res = await fetch(`${API_URL}/application-payments/initiate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          job_order_id: id,
          applicant_email: form.applicant_email,
          applicant_name: form.applicant_name,
          phone: normalizedPhone,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Failed to initiate payment.");
      }

      setPaymentId(data.payment_id);
      setPaymentStatus(data.status || "PENDING");
      setPaymentMessage(data.message || "Payment prompt sent to your phone.");

      setForm((f) => ({
        ...f,
        phone: normalizedPhone,
      }));

      if (data.status === "SUCCESS") {
        setSnackbar({
          open: true,
          message: "Payment confirmed. You can now submit your application.",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: data.message || "Payment prompt sent to your phone.",
          severity: "success",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Failed to initiate payment.",
        severity: "error",
      });
    } finally {
      setInitiatingPayment(false);
    }
  };

  const handleRefreshPaymentStatus = async () => {
    if (!paymentId) return;

    try {
      const res = await fetch(
        `${API_URL}/application-payments/${paymentId}/status`
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Failed to check payment status.");
      }

      setPaymentStatus(data.status || "PENDING");
      setPaymentMessage(data.message || "");

      if (data.status === "SUCCESS") {
        setSnackbar({
          open: true,
          message: "Payment confirmed. You can now submit your application.",
          severity: "success",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Failed to check payment status.",
        severity: "error",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateCoreApplicantFields()) return;

    if (requiresApplicationFee && (paymentStatus !== "SUCCESS" || !paymentId)) {
      setSnackbar({
        open: true,
        message: "Please complete payment before submitting your application.",
        severity: "error",
      });
      return;
    }

    const normalizedPhone = normalizePhone(form.phone);

    setSubmitting(true);
    try {
      const answers = {};
      filteredQuestions.forEach((q) => {
        if (["full name", "email"].includes(q.text.toLowerCase().trim())) return;

        const key = `question_${q.id}`;

        if (q.type === "boolean") {
          answers[key] = !!form[key];
        } else if (q.type === "file") {
          answers[key] = form[key] || null;
        } else {
          answers[key] = form[key] || "";
        }
      });

      const payload = new FormData();

      Object.entries(answers).forEach(([k, v]) => {
        if (
          filteredQuestions.find(
            (q) => `question_${q.id}` === k && q.type === "file"
          )
        ) {
          if (v) payload.append(k, v);
        } else {
          payload.append(k, v);
        }
      });

      payload.append("job_order_id", id);
      payload.append("applicant_name", form.applicant_name);
      payload.append("applicant_email", form.applicant_email);
      payload.append("phone", normalizedPhone);
      payload.append("resume", form.resume);
      payload.append("answers", JSON.stringify(answers));
      // payload.append("payment_id", paymentId);
      if (paymentId) {
        payload.append("payment_id", paymentId);
      }

      const res = await fetch(`${API_URL}/applications/`, {
        method: "POST",
        body: payload,
      });

      if (!res.ok) {
        let errMsg = "Failed to submit application";
        try {
          const data = await res.json();
          if (data.detail) {
            errMsg = data.detail;
          } else if (data.error && (data.error.message || data.error.detail)) {
            errMsg = data.error.message || data.error.detail;
          }
        } catch {}
        setSnackbar({ open: true, message: errMsg, severity: "error" });
        throw new Error(errMsg);
      }

      setSnackbar({
        open: true,
        message: "Application submitted successfully!",
        severity: "success",
      });
      navigate("/thank-you");
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Failed to submit application.",
        severity: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "grid",
          placeItems: "center",
          bgcolor: ui.pageBg,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress
            sx={{
              color: ui.accent,
              mb: 2,
            }}
          />
          <Typography sx={{ color: ui.mid, fontFamily: brandSans }}>
            Loading application page...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error || !job) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "grid",
          placeItems: "center",
          bgcolor: ui.pageBg,
          px: 2,
        }}
      >
        <Paper
          sx={{
            maxWidth: 560,
            width: "100%",
            p: 4,
            borderRadius: "24px",
            border: `1px solid ${ui.border}`,
            background: ui.cardBg,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: brandSans,
              fontWeight: 800,
              fontSize: "28px",
              color: ui.text,
              mb: 1,
            }}
          >
            Job not available
          </Typography>
          <Typography sx={{ color: ui.mid, mb: 3 }}>
            {error || "We could not load this job right now."}
          </Typography>
          <Button
            onClick={() => navigate("/jobs")}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              px: 2.5,
              py: 1.1,
              fontWeight: 700,
              background: ui.accent,
              boxShadow: `0 16px 40px ${alpha(ui.accent, 0.24)}`,
              "&:hover": {
                background: ui.accent,
                filter: "brightness(1.08)",
              },
            }}
          >
            View other jobs
          </Button>
        </Paper>
      </Box>
    );
  }

  const allQuestions = Array.isArray(job.questions) ? job.questions : [];
  const filteredQuestions = allQuestions;

  const defaultQuestions = filteredQuestions
    .filter((q) => q.is_default)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const otherQuestions = filteredQuestions
    .filter((q) => !q.is_default)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const locations = Array.isArray(job.locations) ? job.locations : [];
  const jobTypes = Array.isArray(job.job_types) ? job.job_types : [];

  const sharedFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px",
      background: ui.fieldBg,
      color: ui.text,
      transition: "all .2s ease",
      "& fieldset": {
        borderColor: ui.border,
      },
      "&:hover fieldset": {
        borderColor: ui.borderStrong,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 0 4px ${alpha(ui.accent, 0.12)}`,
      },
      "&.Mui-focused fieldset": {
        borderColor: ui.accent,
      },
    },
    "& .MuiInputLabel-root": {
      color: ui.mid,
      fontWeight: 500,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: ui.accent,
    },
    "& .MuiFormHelperText-root": {
      color: ui.muted,
      mx: 0.25,
      mt: 1,
    },
  };

  const chipSx = {
    borderRadius: 999,
    fontWeight: 700,
    fontSize: "12px",
    background: alpha(ui.accent, dark ? 0.12 : 0.08),
    color: ui.accent,
    border: `1px solid ${alpha(ui.accent, 0.24)}`,
    "& .MuiChip-label": {
      px: 1.4,
    },
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: ui.pageBg,
        color: ui.text,
        pt: { xs: 11, md: 13 },
        pb: 8,
        position: "relative",
        overflow: "hidden",
        fontFamily: brandSans,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: dark
            ? `radial-gradient(circle at 15% 10%, ${alpha(ui.accent, 0.12)} 0%, transparent 26%),
               radial-gradient(circle at 85% 20%, rgba(56,189,248,0.10) 0%, transparent 24%)`
            : `radial-gradient(circle at 15% 10%, ${alpha(ui.accent, 0.08)} 0%, transparent 24%),
               radial-gradient(circle at 85% 20%, rgba(79,70,229,0.06) 0%, transparent 22%)`,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            overflow: "hidden",
            borderRadius: "28px",
            border: `1px solid ${ui.border}`,
            background: dark
              ? `linear-gradient(135deg, ${alpha(ui.accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
              : `linear-gradient(135deg, ${alpha(ui.accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
            boxShadow: dark
              ? "0 32px 80px rgba(0,0,0,0.45)"
              : "0 32px 80px rgba(15,15,26,0.08)",
          }}
        >
          <Grid container>
            <Grid item xs={12} md={7.5}>
              <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
                <Button
                  onClick={() => navigate(-1)}
                  variant="text"
                  sx={{
                    mb: 2.5,
                    px: 0,
                    minWidth: 0,
                    textTransform: "none",
                    fontWeight: 600,
                    color: ui.mid,
                    "&:hover": {
                      background: "transparent",
                      color: ui.accent,
                    },
                  }}
                >
                  ← Back
                </Button>

                <SectionEyebrow color={ui.accent} mono={brandMono}>
                  AjiraHQ · Application
                </SectionEyebrow>

                <Typography
                  sx={{
                    mt: 2,
                    color: ui.text,
                    fontWeight: 800,
                    fontSize: "clamp(34px, 5vw, 54px)",
                    lineHeight: 1.04,
                    letterSpacing: "-0.03em",
                    maxWidth: 760,
                  }}
                >
                  Apply for {job.job_title}
                </Typography>

                <Typography
                  sx={{
                    mt: 2.5,
                    maxWidth: 620,
                    color: ui.mid,
                    fontSize: { xs: "16px", md: "17px" },
                    lineHeight: 1.8,
                  }}
                >
                  A clean, structured application flow built for fast hiring. Fill in
                  your details, complete payment if required, and submit your
                  application in one place.
                </Typography>

                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  {locations.map((loc, idx) => (
                    <Chip
                      key={loc.id || loc.name || idx}
                      label={loc.name}
                      sx={chipSx}
                    />
                  ))}

                  {jobTypes.map((type, idx) => (
                    <Chip
                      key={type.id || type.name || idx}
                      label={type.name}
                      sx={{
                        ...chipSx,
                        background: dark
                          ? "rgba(255,255,255,0.04)"
                          : "rgba(15,15,26,0.03)",
                        color: ui.text,
                        border: `1px solid ${ui.border}`,
                      }}
                    />
                  ))}

                  {!locations.length && !jobTypes.length && (
                    <Chip label="Open role" sx={chipSx} />
                  )}
                </Box>

                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2.5,
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: ui.muted,
                        fontSize: "11px",
                        letterSpacing: "0.14em",
                        textTransform: "uppercase",
                        fontFamily: brandMono,
                        mb: 0.75,
                      }}
                    >
                      Apply before
                    </Typography>
                    <Typography sx={{ color: ui.text, fontWeight: 700 }}>
                      {formatDeadline(job.end_date)}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        color: ui.muted,
                        fontSize: "11px",
                        letterSpacing: "0.14em",
                        textTransform: "uppercase",
                        fontFamily: brandMono,
                        mb: 0.75,
                      }}
                    >
                      Application fee
                    </Typography>
                    <Typography sx={{ color: ui.text, fontWeight: 700 }}>
                      {requiresApplicationFee
                        ? `${applicationFeeCurrency} ${applicationFeeAmount}`
                        : "No fee"}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    mt: 4,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1.5,
                  }}
                >
                  <Button
                    onClick={scrollToForm}
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      borderRadius: "12px",
                      px: 2.8,
                      py: 1.25,
                      fontWeight: 700,
                      background: ui.accent,
                      color: "#fff",
                      boxShadow: `0 16px 40px ${alpha(ui.accent, 0.24)}`,
                      "&:hover": {
                        background: ui.accent,
                        filter: "brightness(1.08)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Start Application →
                  </Button>

                  <Button
                    onClick={() => navigate("/jobs")}
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      borderRadius: "12px",
                      px: 2.6,
                      py: 1.2,
                      fontWeight: 600,
                      borderColor: ui.borderStrong,
                      color: ui.mid,
                      "&:hover": {
                        borderColor: ui.accent,
                        color: ui.accent,
                        background: "transparent",
                      },
                    }}
                  >
                    View other jobs
                  </Button>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4.5}>
              <Box
                sx={{
                  height: "100%",
                  p: { xs: 3, sm: 4, md: 5 },
                  borderTop: { xs: `1px solid ${ui.border}`, md: "none" },
                  borderLeft: { xs: "none", md: `1px solid ${ui.border}` },
                  background: dark
                    ? "rgba(8,12,24,0.45)"
                    : "rgba(255,255,255,0.55)",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: "22px",
                    border: `1px solid ${ui.border}`,
                    background: dark
                      ? "rgba(13,18,32,0.9)"
                      : "rgba(255,255,255,0.88)",
                  }}
                >
                  <SectionEyebrow color={ui.accent} mono={brandMono}>
                    Quick checklist
                  </SectionEyebrow>

                  <Box sx={{ mt: 2.5, display: "grid", gap: 2 }}>
                    {[
                      "Fill in your personal details",
                      "Upload your updated resume",
                      "Answer any additional screening questions",
                      requiresApplicationFee
                        ? "Complete the M-Pesa application fee"
                        : "No application fee required",
                    ].map((item) => (
                      <Box
                        key={item}
                        sx={{
                          display: "flex",
                          gap: 1.25,
                          alignItems: "flex-start",
                        }}
                      >
                        <Box
                          sx={{
                            mt: 0.65,
                            width: 18,
                            height: 18,
                            borderRadius: 999,
                            display: "grid",
                            placeItems: "center",
                            bgcolor: alpha(ui.accent, 0.14),
                            color: ui.accent,
                            fontSize: "11px",
                            fontWeight: 800,
                            flexShrink: 0,
                          }}
                        >
                          ✓
                        </Box>
                        <Typography
                          sx={{
                            color: ui.mid,
                            fontSize: "14px",
                            lineHeight: 1.75,
                            fontWeight: 500,
                          }}
                        >
                          {item}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  <Divider sx={{ my: 2.5, borderColor: ui.border }} />

                  <Typography
                    sx={{
                      color: ui.muted,
                      fontSize: "12px",
                      lineHeight: 1.75,
                    }}
                  >
                    Your phone number will be used for payment confirmation and your
                    email will be used for application updates.
                  </Typography>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        <Grid container spacing={3}>
          <Grid item xs={12} lg={5}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: "24px",
                border: `1px solid ${ui.border}`,
                background: ui.cardBg,
                boxShadow: dark
                  ? "0 20px 50px rgba(0,0,0,0.28)"
                  : "0 20px 50px rgba(15,15,26,0.05)",
              }}
            >
              <SectionEyebrow color={ui.accent} mono={brandMono}>
                Role overview
              </SectionEyebrow>

              <Typography
                sx={{
                  mt: 2,
                  color: ui.text,
                  fontWeight: 800,
                  fontSize: "clamp(26px, 3vw, 36px)",
                  lineHeight: 1.08,
                  letterSpacing: "-0.03em",
                }}
              >
                About this role
              </Typography>

              <Typography
                sx={{
                  mt: 1.25,
                  color: ui.mid,
                  fontSize: "15px",
                  lineHeight: 1.8,
                }}
              >
                Review the role details carefully before submitting your
                application.
              </Typography>

              <Box
                sx={{
                  mt: 3,
                  p: { xs: 2.25, md: 2.75 },
                  borderRadius: "18px",
                  border: `1px solid ${ui.border}`,
                  background: dark ? "rgba(8,12,24,0.55)" : ui.surfaceBg,
                  color: ui.text,
                  "& h1, & h2, & h3, & h4": {
                    color: ui.text,
                    fontWeight: 800,
                    lineHeight: 1.2,
                    letterSpacing: "-0.02em",
                    mt: 0,
                    mb: 1.5,
                  },
                  "& p": {
                    color: ui.mid,
                    lineHeight: 1.9,
                    fontSize: "15px",
                    my: 0,
                    mb: 2,
                  },
                  "& ul, & ol": {
                    pl: 2.5,
                    mb: 2,
                    color: ui.mid,
                  },
                  "& li": {
                    mb: 1,
                    lineHeight: 1.8,
                  },
                  "& strong": {
                    color: ui.text,
                  },
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: cleanJobDescription(
                      job.job && job.job_description
                        ? job.job_description
                        : job.job_description || "No job description provided."
                    ),
                  }}
                />
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} lg={7}>
            <Paper
              id="apply-form"
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: "24px",
                border: `1px solid ${ui.border}`,
                background: ui.cardBg,
                boxShadow: dark
                  ? "0 20px 50px rgba(0,0,0,0.28)"
                  : "0 20px 50px rgba(15,15,26,0.05)",
              }}
            >
              <SectionEyebrow color={ui.accent} mono={brandMono}>
                Candidate application
              </SectionEyebrow>

              <Typography
                sx={{
                  mt: 2,
                  color: ui.text,
                  fontWeight: 800,
                  fontSize: "clamp(26px, 3vw, 36px)",
                  lineHeight: 1.08,
                  letterSpacing: "-0.03em",
                }}
              >
                Application form
              </Typography>

              <Typography
                sx={{
                  mt: 1.25,
                  color: ui.mid,
                  fontSize: "15px",
                  lineHeight: 1.8,
                  mb: 3,
                }}
              >
                Complete the fields below. Required fields should be filled in
                before payment and submission.
              </Typography>

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2.2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Full Name"
                      name="applicant_name"
                      required
                      fullWidth
                      value={form.applicant_name || ""}
                      onChange={handleChange}
                      disabled={submitting}
                      sx={sharedFieldSx}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Email"
                      name="applicant_email"
                      required
                      type="email"
                      fullWidth
                      value={form.applicant_email || ""}
                      onChange={handleChange}
                      disabled={submitting}
                      sx={sharedFieldSx}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Phone Number"
                      name="phone"
                      type="tel"
                      required
                      fullWidth
                      value={form.phone || ""}
                      onChange={handleChange}
                      disabled={submitting}
                      inputProps={{ inputMode: "tel" }}
                      helperText="Use a number that can receive the M-Pesa prompt."
                      sx={sharedFieldSx}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        height: "100%",
                        p: 2,
                        borderRadius: "16px",
                        border: `1px solid ${ui.border}`,
                        background: ui.fieldBg,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: ui.text,
                          fontWeight: 600,
                          mb: 1,
                        }}
                      >
                        Resume *
                      </Typography>

                      <Button
                        component="label"
                        variant="outlined"
                        disabled={submitting}
                        sx={{
                          alignSelf: "flex-start",
                          textTransform: "none",
                          fontWeight: 700,
                          borderRadius: "12px",
                          px: 2,
                          py: 1.1,
                          borderColor: alpha(ui.accent, 0.26),
                          color: ui.accent,
                          background: alpha(ui.accent, 0.06),
                          "&:hover": {
                            borderColor: ui.accent,
                            background: alpha(ui.accent, 0.1),
                          },
                        }}
                      >
                        Upload Resume
                        <input
                          type="file"
                          name="resume"
                          accept=".pdf,.doc,.docx,application/pdf,application/msword"
                          hidden
                          required
                          onChange={(e) =>
                            setForm((f) => ({
                              ...f,
                              resume: e.target.files?.[0] || null,
                            }))
                          }
                          disabled={submitting}
                        />
                      </Button>

                      <Typography
                        sx={{
                          mt: 1.25,
                          color: form.resume ? ui.mid : ui.muted,
                          fontSize: "13px",
                          lineHeight: 1.7,
                          fontFamily: form.resume ? brandMono : brandSans,
                          wordBreak: "break-word",
                        }}
                      >
                        {form.resume
                          ? `Selected: ${form.resume.name}`
                          : "Accepted formats: PDF, DOC, DOCX"}
                      </Typography>
                    </Box>
                  </Grid>

                  {defaultQuestions
                    .filter(
                      (q) =>
                        !["full name", "email"].includes(
                          q.text.toLowerCase().trim()
                        )
                    )
                    .map((q) => (
                      <Grid item xs={12} key={q.id}>
                        <QuestionField
                          q={q}
                          value={form[`question_${q.id}`]}
                          onChange={handleChange}
                          form={form}
                          setForm={setForm}
                          submitting={submitting}
                          ui={ui}
                          brandMono={brandMono}
                        />
                      </Grid>
                    ))}

                  {defaultQuestions.length > 0 && otherQuestions.length > 0 && (
                    <Grid item xs={12}>
                      <Divider
                        sx={{
                          my: 0.5,
                          borderColor: ui.border,
                        }}
                      />
                    </Grid>
                  )}

                  {otherQuestions
                    .filter(
                      (q) =>
                        !["full name", "email"].includes(
                          q.text.toLowerCase().trim()
                        )
                    )
                    .map((q) => (
                      <Grid item xs={12} key={q.id}>
                        <QuestionField
                          q={q}
                          value={form[`question_${q.id}`]}
                          onChange={handleChange}
                          form={form}
                          setForm={setForm}
                          submitting={submitting}
                          ui={ui}
                          brandMono={brandMono}
                        />
                      </Grid>
                    ))}

                  {requiresApplicationFee && (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          mt: 1,
                          p: { xs: 2.25, md: 3 },
                          borderRadius: "20px",
                          border: `1px solid ${alpha(ui.accent, 0.26)}`,
                          background: dark
                            ? `linear-gradient(135deg, ${alpha(
                                ui.accent,
                                0.14
                              )}, rgba(13,18,32,0.95))`
                            : `linear-gradient(135deg, ${alpha(
                                ui.accent,
                                0.08
                              )}, #f8f8fb)`,
                        }}
                      >
                        <SectionEyebrow color={ui.accent} mono={brandMono}>
                          Payment
                        </SectionEyebrow>

                        <Typography
                          sx={{
                            mt: 2,
                            color: ui.text,
                            fontWeight: 800,
                            fontSize: "24px",
                            lineHeight: 1.12,
                            letterSpacing: "-0.02em",
                          }}
                        >
                          Application fee
                        </Typography>

                        <Typography
                          sx={{
                            mt: 1,
                            color: ui.mid,
                            lineHeight: 1.8,
                          }}
                        >
                          {applicationFeeDescription}:{" "}
                          <Box component="span" sx={{ color: ui.text, fontWeight: 800 }}>
                            {applicationFeeCurrency} {applicationFeeAmount}
                          </Box>
                        </Typography>

                        {/* <FormControlLabel
                          sx={{
                            mt: 1.25,
                            alignItems: "flex-start",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              color: ui.mid,
                              fontSize: "14px",
                              lineHeight: 1.75,
                            },
                          }}
                          control={
                            <Checkbox
                              checked={paymentConsent}
                              onChange={(e) => setPaymentConsent(e.target.checked)}
                              disabled={
                                submitting ||
                                initiatingPayment ||
                                paymentStatus === "SUCCESS"
                              }
                              sx={{
                                color: alpha(ui.accent, 0.6),
                                "&.Mui-checked": {
                                  color: ui.accent,
                                },
                              }}
                            />
                          }
                          label={`I understand that submitting this application requires a non-refundable application fee of ${applicationFeeCurrency} ${applicationFeeAmount}.`}
                        /> */}

                        <FormControlLabel
                          sx={{
                            mt: 1.25,
                            alignItems: "flex-start",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              color: ui.mid,
                              fontSize: "14px",
                              lineHeight: 1.75,
                            },
                          }}
                          control={
                            <Checkbox
                              checked={paymentConsent}
                              onChange={(e) => setPaymentConsent(e.target.checked)}
                              disabled={
                                submitting ||
                                initiatingPayment ||
                                paymentStatus === "SUCCESS"
                              }
                              sx={{
                                color: alpha(ui.accent, 0.6),
                                "&.Mui-checked": {
                                  color: ui.accent,
                                },
                              }}
                            />
                          }
                          label={
                            <Box component="span">
                              <Box component="span">
                                {`I understand that submitting this application requires a non-refundable application fee of ${applicationFeeCurrency} ${applicationFeeAmount}. `}
                              </Box>
                              <Link
                                component="button"
                                type="button"
                                underline="hover"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setFeeNoticeOpen(true);
                                }}
                                sx={{
                                  color: ui.accent,
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  verticalAlign: "baseline",
                                }}
                              >
                                Why is this charged?
                              </Link>
                            </Box>
                          }
                        />

                        <Box
                          sx={{
                            mt: 2,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1.5,
                          }}
                        >
                          <Button
                            type="button"
                            onClick={handleInitiatePayment}
                            disabled={
                              submitting ||
                              initiatingPayment ||
                              paymentStatus === "SUCCESS" ||
                              !paymentConsent
                            }
                            variant="contained"
                            sx={{
                              textTransform: "none",
                              borderRadius: "12px",
                              px: 2.6,
                              py: 1.2,
                              fontWeight: 700,
                              background: ui.accent,
                              color: "#fff",
                              boxShadow: `0 16px 40px ${alpha(ui.accent, 0.24)}`,
                              "&:hover": {
                                background: ui.accent,
                                filter: "brightness(1.08)",
                              },
                            }}
                          >
                            {initiatingPayment
                              ? "Initiating Payment..."
                              : paymentStatus === "SUCCESS"
                              ? "Payment Completed"
                              : `Pay ${applicationFeeCurrency} ${applicationFeeAmount}`}
                          </Button>

                          {paymentId && paymentStatus !== "SUCCESS" && (
                            <Button
                              type="button"
                              onClick={handleRefreshPaymentStatus}
                              disabled={submitting || initiatingPayment}
                              variant="outlined"
                              sx={{
                                textTransform: "none",
                                borderRadius: "12px",
                                px: 2.4,
                                py: 1.15,
                                fontWeight: 600,
                                borderColor: ui.borderStrong,
                                color: ui.mid,
                                "&:hover": {
                                  borderColor: ui.accent,
                                  color: ui.accent,
                                  background: "transparent",
                                },
                              }}
                            >
                              Refresh Payment Status
                            </Button>
                          )}
                        </Box>

                        {paymentMessage && (
                          <Typography
                            sx={{
                              mt: 1.5,
                              color:
                                paymentStatus === "SUCCESS"
                                  ? dark
                                    ? "#86efac"
                                    : "#15803d"
                                  : paymentStatus === "FAILED" ||
                                    paymentStatus === "CANCELLED" ||
                                    paymentStatus === "EXPIRED"
                                  ? dark
                                    ? "#fca5a5"
                                    : "#dc2626"
                                  : ui.mid,
                              fontSize: "14px",
                              lineHeight: 1.75,
                            }}
                          >
                            {paymentMessage}
                          </Typography>
                        )}

                        {paymentStatus === "PENDING" && (
                          <Typography
                            sx={{
                              mt: 1,
                              color: ui.muted,
                              fontSize: "13px",
                              lineHeight: 1.75,
                            }}
                          >
                            Check your phone and complete the M-Pesa prompt. The
                            submit button will unlock automatically once payment is
                            confirmed.
                          </Typography>
                        )}

                        {paymentStatus === "SUCCESS" && (
                          <Typography
                            sx={{
                              mt: 1,
                              color: dark ? "#86efac" : "#15803d",
                              fontSize: "13px",
                              lineHeight: 1.75,
                              fontWeight: 600,
                            }}
                          >
                            Payment confirmed. You can now submit your application.
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      disabled={
                        submitting ||
                        (requiresApplicationFee &&
                          (paymentStatus !== "SUCCESS" || !paymentId))
                      }
                      variant="contained"
                      sx={{
                        mt: 1,
                        textTransform: "none",
                        borderRadius: "14px",
                        py: 1.45,
                        fontWeight: 800,
                        fontSize: "15px",
                        background:
                          requiresApplicationFee &&
                          (paymentStatus !== "SUCCESS" || !paymentId)
                            ? dark
                              ? "rgba(255,255,255,0.08)"
                              : "#e5e7eb"
                            : ui.accent,
                        color:
                          requiresApplicationFee &&
                          (paymentStatus !== "SUCCESS" || !paymentId)
                            ? ui.muted
                            : "#fff",
                        boxShadow:
                          requiresApplicationFee &&
                          (paymentStatus !== "SUCCESS" || !paymentId)
                            ? "none"
                            : `0 18px 44px ${alpha(ui.accent, 0.24)}`,
                        "&:hover": {
                          background:
                            requiresApplicationFee &&
                            (paymentStatus !== "SUCCESS" || !paymentId)
                              ? dark
                                ? "rgba(255,255,255,0.08)"
                                : "#e5e7eb"
                              : ui.accent,
                          filter:
                            requiresApplicationFee &&
                            (paymentStatus !== "SUCCESS" || !paymentId)
                              ? "none"
                              : "brightness(1.08)",
                        },
                      }}
                    >
                      {submitting
                        ? "Submitting..."
                        : requiresApplicationFee &&
                          (paymentStatus !== "SUCCESS" || !paymentId)
                        ? "Complete Payment to Submit Application"
                        : "Submit Application"}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Dialog
        open={feeNoticeOpen}
        onClose={() => setFeeNoticeOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            fontWeight: 800,
            color: ui.text,
            letterSpacing: "-0.02em",
          }}
        >
          Online Application Fee Notice – Averdex Recruitment Agency
        </DialogTitle>

        <DialogContent dividers>
          {/* <Typography
            sx={{
              color: ui.mid,
              fontSize: "14px",
              lineHeight: 1.85,
              mb: 2,
            }}
          >
            To continue offering reliable recruitment services and maintain a serious
            pool of applicants, Averdex Recruitment Agency has introduced a{" "}
            <Box component="span" sx={{ fontWeight: 700, color: ui.text }}>
              non-refundable online application support fee of KES 1,000 for selected
              overseas opportunities
            </Box>{" "}
            and{" "}
            <Box component="span" sx={{ fontWeight: 700, color: ui.text }}>
              KES 500 for selected local opportunities
            </Box>
            .
          </Typography> */}
          <Typography
            sx={{
              color: ui.mid,
              fontSize: "14px",
              lineHeight: 1.85,
              mb: 2,
            }}
          >
            To continue offering reliable recruitment services and maintain a serious
            pool of applicants, Averdex Recruitment Agency
            {requiresApplicationFee ? " has introduced a " : " has indicated that this opportunity has "}
            <Box component="span" sx={{ fontWeight: 700, color: ui.text }}>
              {requiresApplicationFee
                ? `non-refundable online application support fee of ${applicationFeeCurrency} ${applicationFeeAmount}`
                : "no application fee requirement"}
            </Box>
            {requiresApplicationFee ? " for this opportunity." : "."}
          </Typography>

          <Typography
            sx={{
              color: ui.text,
              fontWeight: 700,
              mb: 1,
            }}
          >
            This fee is used to:
          </Typography>

          <List sx={{ pt: 0, mb: 1 }}>
            <ListItem sx={{ display: "list-item", py: 0.25, color: ui.mid }}>
              <ListItemText
                primary="Facilitate basic document review and profile verification"
                primaryTypographyProps={{
                  sx: { color: ui.mid, fontSize: "14px", lineHeight: 1.8 },
                }}
              />
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0.25, color: ui.mid }}>
              <ListItemText
                primary="Help filter out incomplete and non-genuine applications, so we can focus on serious candidates"
                primaryTypographyProps={{
                  sx: { color: ui.mid, fontSize: "14px", lineHeight: 1.8 },
                }}
              />
            </ListItem>
          </List>

          <Typography
            sx={{
              color: ui.text,
              fontWeight: 700,
              mt: 2,
              mb: 1,
            }}
          >
            Important:
          </Typography>

          <List sx={{ pt: 0, mb: 1 }}>
            <ListItem sx={{ display: "list-item", py: 0.25, color: ui.mid }}>
              <ListItemText
                primary="Candidates are required to meet all mandatory requirements, including holding a valid passport for overseas opportunities, before submitting an application."
                primaryTypographyProps={{
                  sx: { color: ui.mid, fontSize: "14px", lineHeight: 1.8 },
                }}
              />
            </ListItem>
            <ListItem sx={{ display: "list-item", py: 0.25, color: ui.mid }}>
              <ListItemText
                primary="Averdex continues to charge the main recruitment fees to employers/clients in line with applicable laws and ethical recruitment standards."
                primaryTypographyProps={{
                  sx: { color: ui.mid, fontSize: "14px", lineHeight: 1.8 },
                }}
              />
            </ListItem>
          </List>

          <Typography
            sx={{
              color: ui.mid,
              fontSize: "14px",
              lineHeight: 1.85,
              mt: 2,
            }}
          >
            By proceeding with your online application, you acknowledge and agree to
            these terms.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setFeeNoticeOpen(false)}
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              px: 2.5,
              fontWeight: 700,
              background: ui.accent,
              "&:hover": {
                background: ui.accent,
                filter: "brightness(1.08)",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4500}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity || "info"}
          variant="filled"
          sx={{
            width: "100%",
            borderRadius: "12px",
            fontWeight: 600,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
